<div *ngIf="pagingOptions && pagingOptions.pages.length > 1" class="row gx-1" [ngClass]="centered ? 'justify-content-center' : ''">
	<div class="col-auto">
		<nav>
			<ul class="pagination mb-0">
				<li class="page-item" [ngClass]="{ 'disabled': pageNum <= 1 }">
					<a class="page-link px-2" href="javascript:void(0)" (click)="setPageNum(pageNum - 1)" aria-label="Previous">
						<fa-icon [icon]="['fas', 'angle-left']"></fa-icon>
					</a>
				</li>
				<li *ngFor="let p of pagingOptions.pages" class="page-item">
					<span *ngIf="p === -1" class="page-link px-2">
						<fa-icon [icon]="['fas', 'ellipsis-h']"></fa-icon>
					</span>
					<a *ngIf="p !== -1" class="page-link px-2" href="javascript:void(0)" (click)="setPageNum(p)"
						[ngClass]="{'cp-current-page': +p === +pageNum, 'disabled': pagingOptions.numPages <= 1}">
						{{ p }}
					</a>
				</li>
				<li class="page-item" [ngClass]="{ 'disabled': pageNum >= pagingOptions.numPages }">
					<a class="page-link px-2" href="javascript:void(0)" (click)="setPageNum(pageNum + 1)" aria-label="Next">
						<fa-icon [icon]="['fas', 'angle-right']"></fa-icon>
					</a>
				</li>
			</ul>
		</nav>
	</div>

	<!-- <div *ngIf="pagingOptions.pagingInfo" class="col-auto">
		<div class="cp-75 lh-1" [innerHTML]="pagingOptions.pagingInfo"></div>
	</div> -->
</div>